/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as AssetImage } from 'Images/assets.svg';

export const AssetIcon = styled(AssetImage)`
  margin-right: 11px !important;
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
  }
`;
AssetIcon.displayName = 'AssetIcon';
